import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  insertMemberLabel (params) { // 新增会员标签
    return axios.post(global.MMC_INFO + '/memberLabel/insertMemberLabel', params)
  },
  deleteMemberLabel (params) { // 删除会员标签
    return axios.post(global.MMC_INFO + '/memberLabel/deleteMemberLabel', params)
  },
  updateMemberLabel (params) { // 修改会员标签
    return axios.post(global.MMC_INFO + '/memberLabel/updateMemberLabel', params)
  },
  updateMemberLabelStart (params) { // 启用会员标签
    return axios.post(global.MMC_INFO + '/memberLabel/updateMemberLabelStart', params)
  },
  updateMemberLabelStop (params) { // 停用会员标签
    return axios.post(global.MMC_INFO + '/memberLabel/updateMemberLabelStop', params)
  },
  getMemberLavelAss (params) { // 获取会员已有标签
    return axios.post(global.MMC_INFO + '/memberLabelAss/findMemberLabelAss', params)
  },
  insertMemberLabelAss (params) { // 会员插入会员标签
    return axios.post(global.MMC_INFO + '/memberLabelAss/insertMemberLabelAss', params)
  },
  deleteByMemberIdLabelId (params) { // 删除会员已有标签
    return axios.post(global.MMC_INFO + '/memberLabelAss/deleteByMemberIdLabelId', params)
  },
  updateMemberAddFriends (params) { // 添加好友
    return axios.post(global.MMC_INFO + '/member/updateMemberAddFriends', params)
  }
}
// global.MMC_INFO http://192.168.9.20:7001/msi/mmc/info



// WEBPACK FOOTER //
// ./src/request/mmc/memberLabel.js